import React from 'react';
import styled from 'styled-components';

import CalendarMonthOutlinedIcon from '@mui/icons-material/CalendarMonthOutlined';

interface Props {
  tagName: string | null;
}

const getBackgroundColor = (tagName) => {
  switch (tagName) {
    case '日程短縮可':
      return '#FFF4EA';
    default:
      return '#F0FDF4';
  }
};

const getColor = (tagName) => {
  switch (tagName) {
    case '日程短縮可':
      return '#FF6E2E';
    default:
      return '#15803D';
  }
};

const Tag = ({ tagName }: Props) => (
  <StyledTag tagName={tagName}>
    <CalendarMonthOutlinedIcon sx={{ width: 20, height: 20 }} />
    <TextXs>{tagName}</TextXs>
  </StyledTag>
);

export default Tag;

const StyledTag = styled.div<Props>`
  position: absolute;
  top: 8px;
  left: 8px;
  background-color: ${({ tagName }) => getBackgroundColor(tagName)};
  color: ${({ tagName }) => getColor(tagName)};
  padding: 2px 12px;
  border-radius: 40px;
  align-items: center;
  display: inline-flex;
  gap: 2px;
  /* RoundButton と同じ値（サムネの上にアイコンボタンを表示するため） */
  z-index: 10;
`;

const TextXs = styled.span`
  text-align: center;
  /* Bold/text-xs */
  font-size: 12px;
  font-style: normal;
  font-weight: 600;
  line-height: 16px;
`;
